import React from "react";
import ContentLoader from "react-content-loader";

const DishLoader = (props) => (
  <ContentLoader
    speed={1}
    viewBox="0 0 440 600"
    backgroundColor="#ffffff88"
    foregroundColor="#ffffff44"
    width={'90vw'}
    {...props}
  >
    <rect x="0" y="00" rx="3" ry="3" width="200" height="36" />
    <rect x="0" y="42" rx="3" ry="3" width="160" height="24" />
    <rect x="0" y="72" rx="3" ry="3" width="440" height="2" />

    <rect x="0" y="80" rx="3" ry="3" width="100" height="30" />
    <rect x="320" y="80" rx="3" ry="3" width="120" height="30" />
    <rect x="0" y="105" rx="3" ry="3" width="440" height="5" />

    <rect x="0" y="116" rx="3" ry="3" width="80" height="30" />
    <rect x="280" y="116" rx="3" ry="3" width="160" height="30" />
    <rect x="0" y="141" rx="3" ry="3" width="440" height="5" />

    <rect x="0" y="152" rx="3" ry="3" width="130" height="30" />
    <rect x="300" y="152" rx="3" ry="3" width="140" height="30" />
    <rect x="0" y="177" rx="3" ry="3" width="440" height="5" />

    <rect x="0" y="189" rx="3" ry="3" width="440" height="4" />

    <rect x="0" y="200" rx="3" ry="3" width="200" height="36" />
    <rect x="0" y="242" rx="3" ry="3" width="160" height="24" />
    <rect x="0" y="272" rx="3" ry="3" width="440" height="2" />

    <rect x="0" y="280" rx="3" ry="3" width="100" height="30" />
    <rect x="320" y="280" rx="3" ry="3" width="120" height="30" />
    <rect x="0" y="305" rx="3" ry="3" width="440" height="5" />

    <rect x="0" y="316" rx="3" ry="3" width="80" height="30" />
    <rect x="280" y="316" rx="3" ry="3" width="160" height="30" />
    <rect x="0" y="341" rx="3" ry="3" width="440" height="5" />

    <rect x="0" y="352" rx="3" ry="3" width="130" height="30" />
    <rect x="300" y="352" rx="3" ry="3" width="140" height="30" />
    <rect x="0" y="377" rx="3" ry="3" width="440" height="5" />

    <rect x="0" y="389" rx="3" ry="3" width="440" height="4" />

    <rect x="0" y="400" rx="3" ry="3" width="200" height="36" />
    <rect x="0" y="442" rx="3" ry="3" width="160" height="24" />
    <rect x="0" y="472" rx="3" ry="3" width="440" height="2" />

    <rect x="0" y="480" rx="3" ry="3" width="100" height="30" />
    <rect x="320" y="480" rx="3" ry="3" width="120" height="30" />
    <rect x="0" y="505" rx="3" ry="3" width="440" height="5" />

    <rect x="0" y="516" rx="3" ry="3" width="80" height="30" />
    <rect x="280" y="516" rx="3" ry="3" width="160" height="30" />
    <rect x="0" y="541" rx="3" ry="3" width="440" height="5" />

    <rect x="0" y="552" rx="3" ry="3" width="130" height="30" />
    <rect x="300" y="552" rx="3" ry="3" width="140" height="30" />
    <rect x="0" y="577" rx="3" ry="3" width="440" height="5" />

    <rect x="0" y="589" rx="3" ry="3" width="440" height="4" />
  </ContentLoader>
);

export default DishLoader;
